export default __webpack_public_path__ + "static/media/payment_error.01c1f336.svg";